import React, { useEffect, useState } from "react";
import { Card, Col, Divider, Row } from "antd";
import useApi from "../../hooks/useApi";
import { isEmpty } from "../../generalFunctions";
import { BLANK_VALUE } from "../../constants";

const Padhadhikari = () => {
  const [response, request] = useApi("/website/padhadhikari");
  const [padhadhikari, setPadhadhikari] = useState([]);

  useEffect(() => {
    request();
  }, []); //eslint-disable-line

  useEffect(() => {
    if (!isEmpty(response.data) && !response.error && !response.isLoading) {
      setPadhadhikari(response.data);
    }
  }, [response]);

  return (
    <>
      <Row
        gutter={[16, 16]}
        style={{ display: "flex", justifyContent: "center" }}
      >
        {padhadhikari.map(
          (officer, index) =>
            index < 2 && (
              <Col xl={8} lg={8} md={12} sm={24} xs={24} key={officer.id}>
                <Card
                  key={officer.id}
                  hoverable
                  style={{ width: 320, minHeight: 475 }}
                  cover={
                    <img
                      alt={officer.name}
                      src={officer.image}
                      style={{
                        height: 320,
                        objectFit: "cover",
                        objectPosition: "top",
                      }}
                    />
                  }
                >
                  <h2>{officer.name}</h2>
                  <h3>{officer.post}</h3>
                  <h3>{"पंचायत समिती, कागल"}</h3>
                  <Card.Meta description={`गण - ${officer.vibhag}`} />
                  {/* <Card.Meta
                    description={
                      "email: " + (officer.email ? officer.email : BLANK_VALUE)
                    }
                  />
                  <Card.Meta
                    description={
                      "mobile: " +
                      (officer.mobile ? officer.mobile : BLANK_VALUE)
                    }
                  /> */}
                </Card>
              </Col>
            )
        )}
      </Row>
      <Divider />
      <Row gutter={[16, 16]}>
        {padhadhikari.map(
          (officer, index) =>
            index >= 2 && (
              <Col xl={8} lg={8} md={12} sm={24} xs={24} key={officer.id}>
                <Card
                  key={officer.id}
                  hoverable
                  style={{ width: 320, minHeight: 475 }}
                  cover={
                    <img
                      alt={officer.name}
                      src={officer.image}
                      style={{
                        height: 320,
                        objectFit: "cover",
                        objectPosition: "top",
                      }}
                    />
                  }
                >
                  <h2>{officer.name}</h2>
                  <h3>{officer.post}</h3>
                  <h3>{"पंचायत समिती, कागल"}</h3>
                  <Card.Meta description={`गण - ${officer.vibhag}`} />
                  {/* <Card.Meta
                    description={
                      "email: " + (officer.email ? officer.email : BLANK_VALUE)
                    }
                  />
                  <Card.Meta
                    description={
                      "mobile: " +
                      (officer.mobile ? officer.mobile : BLANK_VALUE)
                    }
                  /> */}
                </Card>
              </Col>
            )
        )}
      </Row>
    </>
  );
};

export default Padhadhikari;
